import { render, staticRenderFns } from "./ProjectStateEmailCreate.vue?vue&type=template&id=5183e4d7&"
import script from "./ProjectStateEmailCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectStateEmailCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports